import React from 'react';
import { useResponsive } from '@parsina/framework';

import CreditsWeb from './Credits.web.jsx';
import CreditsMobile from './Credits.mobile.jsx';

// پارسه — two surfaces, one wallet.
//
// Both read the same balance from the shared identity store (src/hooks/useMe.js),
// the same paged ledger, the same gift codes and the same top-up. The `?type=`
// and `?page=` URL contract is identical, so a link opened on either device shows
// the same rows.
//
// The desktop puts the ledger beside a rail of actions; the phone puts «شارژ»
// first, because on a phone that is almost always why the screen was opened.

const CreditsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <CreditsMobile /> : <CreditsWeb />;
};

export default CreditsScreen;
